import React from 'react';
import { DismissRegular } from '@fluentui/react-icons';
import { cn } from '../../helpers/shadcnUtils.helper';
interface Iprops {
  email: string;
  deleteEmail: (email: string) => void;
  disabled?: boolean;
}

const ItemEmail = ({ email, deleteEmail, disabled }: Iprops): JSX.Element => {
  return (
    <div
      className={cn(
        'inline-flex items-center gap-1.5',
        'bg-blue-95 ',
        'py-1 px-2 m-0.5 rounded-lg',
        'text-sm text-neutral-12 ',
      )}
    >
      <span className="max-w-[200px] truncate">{email}</span>
      <button
        type="button"
        onClick={() => deleteEmail(email)}
        aria-label={`Remove ${email}`}
        className="text-base"
        disabled={disabled}
      >
        <DismissRegular />
      </button>
    </div>
  );
};

export default ItemEmail;
